const ADMIN_ROLES = new Set(['admin', 'super-admin', 'owners']);
const ELEVATED_ROLES = new Set(['manager', 'deployer']);

export type RoleVariant = 'admin' | 'elevated' | 'base';

export function roleVariant(role: string): RoleVariant {
  const key = role.toLowerCase();
  return ADMIN_ROLES.has(key) ? 'admin' : ELEVATED_ROLES.has(key) ? 'elevated' : 'base';
}
